import moment from 'moment';
// import { trapFocus } from './focus-trap';
import { Modal } from 'flowbite';

const modalToggle = document.getElementById('modal-floorplan');
// const modal = new Modal(modalToggle);
let modal = null;
if (modalToggle) {
    modal = new Modal(modalToggle);
}

export const FloorplanModal = {
    formatDate(availability_date) {
        var the_date = moment(availability_date, 'MMDDYYYY');
        if (the_date.isBefore(moment(), 'day')) {
            return 'Available';
        }
        return the_date.format('l');
    },
    formatAvailabilityLink(unit) {
        const url = unit.availability_url.replace(/^http:\/\//i, 'https://');

        var formatted_date = moment(unit.availability_date).format('M/D/YYYY');
        var the_date = moment(unit.availability_date, 'MMDDYYYY');
        if (the_date.isBefore(moment(), 'day')) {
            formatted_date = moment().format('M/D/YYYY');
        }

        if (url.includes('?')) {
            return url + '&MoveInDate=' + formatted_date;
        } else {
            return url + '?MoveInDate=' + formatted_date;
        }
    },
    updateModalContent($modal_trigger) {
        var $modal = $('#modal-floorplan');

        var id = $modal_trigger.attr('data-floorplan-id');
        var title = $modal_trigger.attr('data-floorplan-title');
        var beds = $modal_trigger.attr('data-floorplan-beds');
        var baths = $modal_trigger.attr('data-floorplan-baths');
        var image = $modal_trigger.attr('data-floorplan-image');

        var dollarFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        if (image) {
            $('.modal-floorplan__image', $modal)
                .attr('src', image)
                .attr('alt', title);
        } else {
            $('.modal-floorplan__image', $modal)
                .attr(
                    'src',
                    $('.modal-floorplan__image', $modal).attr('data-default')
                )
                .attr('alt', title);
        }
        $('.modal-floorplan__title', $modal).text(title);
        $('.modal-floorplan__beds', $modal).text(beds);
        $('.modal-floorplan__baths', $modal).text(baths);

        $('.modal-floorplan-units').addClass('hidden');
        $('.modal-floorplan-units tbody').empty();
        var hasUnit = false;
        var priceValue = '';
        $.each(window.units, function (i, unit) {
            if (unit.floorplan_id == id) {
                hasUnit = true;
                priceValue = dollarFormatter.format(unit.min_rent) + '-' + dollarFormatter.format(unit.max_rent);
                if(unit.min_rent == unit.max_rent){
                    priceValue = dollarFormatter.format(unit.min_rent);
                }
                var $row = `<tr class="bg-white border-b">
                <td class="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">${
                    unit.title
                }</td>
                <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap ">${
                    unit.sqft
                }</td>
                <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap ">${priceValue}</td>
                <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap ">${FloorplanModal.formatDate(
                    unit.availability_date
                )}</td>
                <td class="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                    <a href="${FloorplanModal.formatAvailabilityLink(
                        unit
                    )}" class="button" target="_blank">Apply Now</a>
                </td>
            </tr>`;
                $('.modal-floorplan-units tbody').append($row);
            }
        });

        if (hasUnit) {
            $('.modal-floorplan-units').removeClass('hidden');
        }
    },
    init() {
        let previousElement = null;
        
        $('[data-floorplan-modal]').on('click', function () {
            // toggleModal('modal-floorplan', true);
            modal.show();
            FloorplanModal.updateModalContent($(this));
            previousElement = $(this);
            // trapFocus(modalToggle);
            $('body').addClass('hide-overflow ');
            return false;
        });

        // set focus on modal close button click
        $(document).on('click', '#modal-floorplan .wc_modal_close',  function (event) {
            window.setTimeout(() => previousElement.focus(), 100);
            $('body').removeClass('hide-overflow ');
            // toggleModal('modal-floorplan', false);
            modal.hide();
        });

        // remove results on click outside
        $(document).on('click', function (event) {
            var $target = $(event.target);
            if (
                !$target.closest('.floorplan-modal-content').length &&
                $('.floorplan-modal-content').is(':visible')
            ) {
                // toggleModal('modal-floorplan', false);
                modal.hide();
                previousElement.focus();
                $('body').removeClass('hide-overflow ');
            }
        });

        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                if (
                    $('#modal-floorplan').length > 0 &&
                    $('#modal-floorplan').is(':visible')
                ) {
                    // toggleModal('modal-floorplan', false);
                    modal.hide();
                    previousElement.focus();
                    $('body').removeClass('hide-overflow ');
                }
            }
        });
    },
};